module.exports = __webpack_public_path__ + "static/media/home_face.25ae665d.png";